import React from "react";

// Constants
const ALPHABET_ROW1 = Array.from("ABCDEFGHIJKLM");
const ALPHABET_ROW2 = Array.from("NOPQRSTUVWXYZ");

const AlphabetFilter = ({ startsWithFromUrl, handleLetterClick }) => (
  <div className="mt-2 flex flex-col items-center gap-1">
    <div className="flex gap-1">
      <button
        onClick={() => handleLetterClick("#")}
        className={`w-6 h-6 text-xs font-medium rounded-md transition-all duration-200
                 ${
                   startsWithFromUrl === "[0-9]"
                     ? "bg-primary-500 text-white shadow-md scale-110 hover:bg-primary-600 dark:bg-gray-800 dark:text-gray-400"
                     : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
                 }`}
      >
        #
      </button>
      {ALPHABET_ROW1.map((letter) => (
        <button
          key={letter}
          onClick={() => handleLetterClick(letter)}
          className={`w-6 h-6 text-xs font-medium rounded-md transition-all duration-200
                   ${
                     startsWithFromUrl === letter
                       ? "bg-primary-500 text-white shadow-md scale-110 hover:bg-primary-600 dark:bg-gray-800 dark:text-gray-400"
                       : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
                   }`}
        >
          {letter}
        </button>
      ))}
    </div>
    <div className="flex gap-1">
      {ALPHABET_ROW2.map((letter) => (
        <button
          key={letter}
          onClick={() => handleLetterClick(letter)}
          className={`w-6 h-6 text-xs font-medium rounded-md transition-all duration-200
                   ${
                     startsWithFromUrl === letter
                       ? "bg-primary-500 text-white shadow-md scale-110 hover:bg-primary-600 dark:bg-gray-800 dark:text-gray-400"
                       : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
                   }`}
        >
          {letter}
        </button>
      ))}
    </div>
  </div>
);

export default AlphabetFilter;
